module.exports = __webpack_public_path__ + "img/plsblogo.43ae61b0.png";